import React from 'react'
import styled from 'styled-components'
import appendQuery from 'append-query'
import ArtistBlocks from 'shared/components/content-blocks/artists'
import ReactionBlocks from 'shared/components/content-blocks/reactions'
import SearchBlocks from 'shared/components/content-blocks/popular-searches'
import ClickAndScrollCarousel from 'shared/components/click-and-scroll-carousel'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { API_URL, WEB_API_KEY } from 'shared/api'
import { IUser } from '@giphy/js-types'

const Container = styled.div`
    padding-bottom: 40px;
`

const PopularSearches = styled(SearchBlocks)`
    margin-bottom: 60px;
`

const Artists = styled(ArtistBlocks)`
    margin-bottom: 60px;
`

const Reactions = styled(ReactionBlocks)`
    margin-bottom: 60px;
`

type Props = {
    user?: IUser
    pingbackId?: string
}

const HomepageContentBlocks = ({ user, pingbackId }: Props) => {
    return (
        <Container>
            <PopularSearches width={1040} />
            <Reactions width={1040} />
            <Artists width={1040} />
            <ClickAndScrollCarousel
                fetchUrl={appendQuery(`${API_URL}stickers/trending`, {
                    api_key: WEB_API_KEY,
                    limit: 25,
                    pingback_id: pingbackId,
                })}
                processor={json => ({ gifs: json.data })}
                groupId={`trendingstickers`}
                title={`Trending Stickers`}
                path={`/stickers`}
                height={140}
                styles={{ margin: `25px 0 50px` }}
                user={user}
                isTracking
                onClick={() => {
                    googleAnalyticsEvent({
                        category: 'Homepage',
                        action: 'Click',
                        label: 'Trending Stickers Carousel',
                    })
                }}
            />
        </Container>
    )
}

export default HomepageContentBlocks
